import React from "react";
import { MailIcon } from "@heroicons/react/solid";

import Input from "../Atoms/Input";
import Button from "../Atoms/Button";
import TextArea from "../Atoms/TextArea";
import HeroIcon from "../Atoms/HeroIcon";
import { useTranslation } from "react-i18next";

interface ContactFormProps {
  onSubmit: (e: any) => void;
  name: string;
  email: string;
  message: string;
  setName: (value: string) => void;
  setEmail: (value: string) => void;
  setMessage: (value: string) => void;
  isLoading?: any;
}
const ContactForm: React.FC<ContactFormProps> = ({
  onSubmit,
  name,
  email,
  message,
  setName,
  setEmail,
  setMessage,
}) => {
  const { t } = useTranslation();

  return (
    <form
      name="contact"
      onSubmit={onSubmit}
      className="lg:w-100 md:w-full flex flex-col items-center w-full md:py-8 md:mt-0 px-5 py-10 text-center"
    >
      <HeroIcon Icon={MailIcon} className="w-10 inline-block mb-4" />
      <h1 className="sm:text-4xl text-3xl font-medium title-font text-black dark:text-white mb-4">
        {t("contactForm.title")}
      </h1>
      <p className="text-base leading-relaxed mb-10 text-black dark:text-white">
        {t("contactForm.description")}
      </p>
      <Input
        name="user_name"
        id="name"
        type="text"
        className="w-full sm:w-1/2 bg-white dark:bg-gray-900 rounded border border-gray-300 dark:border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-900 dark:text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
        value={name}
        onChange={(e: any) => setName(e.target.value)}
        placeholder={t("contactForm.namePlaceholder")}
        required
      />
      <Input
        id="email"
        name="user_email"
        type="email"
        value={email}
        className="w-full sm:w-1/2 bg-white dark:bg-gray-900 rounded border border-gray-300 dark:border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-900 dark:text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
        onChange={(e: any) => setEmail(e.target.value)}
        placeholder={t("contactForm.emailPlaceholder")}
        required
      />
      <div className="w-full sm:w-full  relative mb-4">
        <TextArea
          id="message"
          name="user_message"
          className=" w-full sm:w-1/2 bg-white dark:bg-gray-900 rounded border border-gray-300 dark:border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-900 dark:text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
          value={message}
          onChange={(e: any) => setMessage(e.target.value)}
          placeholder={t("contactForm.messagePlaceholder")}
          rows={3}
          required
        />
      </div>
      <Button
        type="submit"
        className="text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg"
        titleButton={t("contactForm.submit")}
      />
    </form>
  );
};

export default ContactForm;
